export default [
    {
        q: "I live by letting things happen.",
        a: "Dogen",
        c: "32",
        h: "<blockquote>&ldquo;I live by letting things happen.&rdquo; &mdash; <footer>Dogen</footer></blockquote>",
    },
    {
        q: "Friendship is like money, easier made than kept.",
        a: "Samuel Butler",
        c: "48",
        h: "<blockquote>&ldquo;Friendship is like money, easier made than kept.&rdquo; &mdash; <footer>Samuel Butler</footer></blockquote>",
    },
    {
        q: "You can put lipstick on a pig. It's still a pig.",
        a: "Barack Obama",
        c: "48",
        h: "<blockquote>&ldquo;You can put lipstick on a pig. It's still a pig.&rdquo; &mdash; <footer>Barack Obama</footer></blockquote>",
    },
    {
        q: "Don't blame others. it won't make you a better person.",
        a: "Lolly Daskal",
        c: "54",
        h: "<blockquote>&ldquo;Don't blame others. it won't make you a better person.&rdquo; &mdash; <footer>Lolly Daskal</footer></blockquote>",
    },
    {
        q: "Originality is the fine art of remembering what you hear but forgetting where you heard it. ",
        a: "Laurence J. Peter",
        c: "92",
        h: "<blockquote>&ldquo;Originality is the fine art of remembering what you hear but forgetting where you heard it. &rdquo; &mdash; <footer>Laurence J. Peter</footer></blockquote>",
    },
    {
        q: "The fewer the words, the better the prayer.",
        a: "Martin Luther",
        c: "43",
        h: "<blockquote>&ldquo;The fewer the words, the better the prayer.&rdquo; &mdash; <footer>Martin Luther</footer></blockquote>",
    },
    {
        q: "Always dream and shoot higher than you know you can do. Do not bother just to be better than your contemporaries or predecessors. Try to be better than yourself.",
        a: "William Faulkner",
        c: "161",
        h: "<blockquote>&ldquo;Always dream and shoot higher than you know you can do. Do not bother just to be better than your contemporaries or predecessors. Try to be better than yourself.&rdquo; &mdash; <footer>William Faulkner</footer></blockquote>",
    },
    {
        q: "To escape from the world means that one's mind is not concerned with the opinions of the world.",
        a: "Dogen",
        c: "95",
        h: "<blockquote>&ldquo;To escape from the world means that one's mind is not concerned with the opinions of the world.&rdquo; &mdash; <footer>Dogen</footer></blockquote>",
    },
    {
        q: "Don't worry about being successful, but work toward being significant and the success will naturally follow.",
        a: "Oprah Winfrey",
        c: "108",
        h: "<blockquote>&ldquo;Don't worry about being successful, but work toward being significant and the success will naturally follow.&rdquo; &mdash; <footer>Oprah Winfrey</footer></blockquote>",
    },
    {
        q: "All you need is the plan, the road map, and the courage to press on to your destination.",
        a: "Earl Nightingale",
        c: "88",
        h: "<blockquote>&ldquo;All you need is the plan, the road map, and the courage to press on to your destination.&rdquo; &mdash; <footer>Earl Nightingale</footer></blockquote>",
    },
    {
        q: "The pessimist sees difficulty in every opportunity. The optimist sees opportunity in every difficulty.",
        a: "Winston Churchill",
        c: "102",
        h: "<blockquote>&ldquo;The pessimist sees difficulty in every opportunity. The optimist sees opportunity in every difficulty.&rdquo; &mdash; <footer>Winston Churchill</footer></blockquote>",
    },
    {
        q: "Do not look upon this world with fear and loathing. Bravely face whatever the gods offer.",
        a: "Morihei Ueshiba",
        c: "89",
        h: "<blockquote>&ldquo;Do not look upon this world with fear and loathing. Bravely face whatever the gods offer.&rdquo; &mdash; <footer>Morihei Ueshiba</footer></blockquote>",
    },
    {
        q: "It is better to fail in originality than to succeed in imitation.",
        a: "Herman Melville",
        c: "65",
        h: "<blockquote>&ldquo;It is better to fail in originality than to succeed in imitation.&rdquo; &mdash; <footer>Herman Melville</footer></blockquote>",
    },
    {
        q: "Let not your mind run on what you lack as much as on what you have already.",
        a: "Marcus Aurelius",
        c: "75",
        h: "<blockquote>&ldquo;Let not your mind run on what you lack as much as on what you have already.&rdquo; &mdash; <footer>Marcus Aurelius</footer></blockquote>",
    },
    {
        q: "Most people do not really want freedom, because freedom involves responsibility, and most people are frightened of responsibility.",
        a: "Sigmund Freud",
        c: "130",
        h: "<blockquote>&ldquo;Most people do not really want freedom, because freedom involves responsibility, and most people are frightened of responsibility.&rdquo; &mdash; <footer>Sigmund Freud</footer></blockquote>",
    },
    {
        q: "There is no such thing as a great talent without great willpower.",
        a: "Honore de Balzac",
        c: "65",
        h: "<blockquote>&ldquo;There is no such thing as a great talent without great willpower.&rdquo; &mdash; <footer>Honore de Balzac</footer></blockquote>",
    },
    {
        q: "Some of your greatest lessons come from your darkest moments.",
        a: "Roger Lee",
        c: "61",
        h: "<blockquote>&ldquo;Some of your greatest lessons come from your darkest moments.&rdquo; &mdash; <footer>Roger Lee</footer></blockquote>",
    },
    {
        q: "If I cannot do great things. I can do small things in a great way.",
        a: "Martin Luther King, Jr.",
        c: "66",
        h: "<blockquote>&ldquo;If I cannot do great things. I can do small things in a great way.&rdquo; &mdash; <footer>Martin Luther King, Jr.</footer></blockquote>",
    },
    {
        q: "A man should never be ashamed to own that he has been in the wrong, which is but saying, that he is wiser today than yesterday.",
        a: "Jonathan Swift",
        c: "127",
        h: "<blockquote>&ldquo;A man should never be ashamed to own that he has been in the wrong, which is but saying, that he is wiser today than yesterday.&rdquo; &mdash; <footer>Jonathan Swift</footer></blockquote>",
    },
    {
        q: "Deeds will not be less valiant because they are upraised.",
        a: "J.R.R. Tolkien",
        c: "57",
        h: "<blockquote>&ldquo;Deeds will not be less valiant because they are upraised.&rdquo; &mdash; <footer>J.R.R. Tolkien</footer></blockquote>",
    },
    {
        q: "He who has overcome his fears will truly be free.",
        a: "Aristotle",
        c: "49",
        h: "<blockquote>&ldquo;He who has overcome his fears will truly be free.&rdquo; &mdash; <footer>Aristotle</footer></blockquote>",
    },
    {
        q: "A good character is the best tombstone. Carve your name on hearts, not on marble.",
        a: "Charles Spurgeon",
        c: "81",
        h: "<blockquote>&ldquo;A good character is the best tombstone. Carve your name on hearts, not on marble.&rdquo; &mdash; <footer>Charles Spurgeon</footer></blockquote>",
    },
    {
        q: "Life is like playing the violin in public and learning the instrument as one goes on.",
        a: "Samuel Butler",
        c: "85",
        h: "<blockquote>&ldquo;Life is like playing the violin in public and learning the instrument as one goes on.&rdquo; &mdash; <footer>Samuel Butler</footer></blockquote>",
    },
    {
        q: "The great use of life is to spend it for something that will outlast it.",
        a: "William James",
        c: "72",
        h: "<blockquote>&ldquo;The great use of life is to spend it for something that will outlast it.&rdquo; &mdash; <footer>William James</footer></blockquote>",
    },
    {
        q: "Never do things others can do and will do if there are things others cannot do or will not do.",
        a: "Amelia Earhart",
        c: "94",
        h: "<blockquote>&ldquo;Never do things others can do and will do if there are things others cannot do or will not do.&rdquo; &mdash; <footer>Amelia Earhart</footer></blockquote>",
    },
    {
        q: "Make yourself so useful to other people, that they think you are irreplaceable.",
        a: "Og Mandino",
        c: "79",
        h: "<blockquote>&ldquo;Make yourself so useful to other people, that they think you are irreplaceable.&rdquo; &mdash; <footer>Og Mandino</footer></blockquote>",
    },
    {
        q: "Routine life is unbearable, and most people only think about how to escape into the world of fantasy and dreams.",
        a: "Robert Greene",
        c: "112",
        h: "<blockquote>&ldquo;Routine life is unbearable, and most people only think about how to escape into the world of fantasy and dreams.&rdquo; &mdash; <footer>Robert Greene</footer></blockquote>",
    },
    {
        q: "Heal the past, live the present, dream the future.",
        a: "Mary Engelbreit",
        c: "50",
        h: "<blockquote>&ldquo;Heal the past, live the present, dream the future.&rdquo; &mdash; <footer>Mary Engelbreit</footer></blockquote>",
    },
    {
        q: "Everything around us is made up of energy. To attract positive things in your life, start by giving off positive energy.",
        a: "Celestine Chua",
        c: "120",
        h: "<blockquote>&ldquo;Everything around us is made up of energy. To attract positive things in your life, start by giving off positive energy.&rdquo; &mdash; <footer>Celestine Chua</footer></blockquote>",
    },
    {
        q: "It is well known that those who do not trust themselves never trust others.",
        a: "Alfred Adler",
        c: "75",
        h: "<blockquote>&ldquo;It is well known that those who do not trust themselves never trust others.&rdquo; &mdash; <footer>Alfred Adler</footer></blockquote>",
    },
    {
        q: "Guilt is perhaps the most painful companion of death.",
        a: "Coco Chanel",
        c: "53",
        h: "<blockquote>&ldquo;Guilt is perhaps the most painful companion of death.&rdquo; &mdash; <footer>Coco Chanel</footer></blockquote>",
    },
    {
        q: "In order to be irreplaceable one must always be different.",
        a: "Coco Chanel",
        c: "58",
        h: "<blockquote>&ldquo;In order to be irreplaceable one must always be different.&rdquo; &mdash; <footer>Coco Chanel</footer></blockquote>",
    },
    {
        q: "You may think I'm small, but I have a universe inside my mind.",
        a: "Yoko Ono",
        c: "62",
        h: "<blockquote>&ldquo;You may think I'm small, but I have a universe inside my mind.&rdquo; &mdash; <footer>Yoko Ono</footer></blockquote>",
    },
    {
        q: "Concentrated power has always been the enemy of liberty.",
        a: "Ronald Reagan",
        c: "56",
        h: "<blockquote>&ldquo;Concentrated power has always been the enemy of liberty.&rdquo; &mdash; <footer>Ronald Reagan</footer></blockquote>",
    },
    {
        q: "The most effective way to do it, is to do it.",
        a: "Amelia Earhart",
        c: "45",
        h: "<blockquote>&ldquo;The most effective way to do it, is to do it.&rdquo; &mdash; <footer>Amelia Earhart</footer></blockquote>",
    },
    {
        q: "All men who have achieved great things have been great dreamers. ",
        a: "Orison Swett Marden",
        c: "65",
        h: "<blockquote>&ldquo;All men who have achieved great things have been great dreamers. &rdquo; &mdash; <footer>Orison Swett Marden</footer></blockquote>",
    },
    {
        q: "To travel is to be alive, but to get somewhere is to be dead.",
        a: "Alan Watts",
        c: "61",
        h: "<blockquote>&ldquo;To travel is to be alive, but to get somewhere is to be dead.&rdquo; &mdash; <footer>Alan Watts</footer></blockquote>",
    },
    {
        q: "Do what you can, with what you have, where you are.",
        a: "Theodore Roosevelt",
        c: "51",
        h: "<blockquote>&ldquo;Do what you can, with what you have, where you are.&rdquo; &mdash; <footer>Theodore Roosevelt</footer></blockquote>",
    },
    {
        q: "The only person you should try to be better than is the person you were yesterday.",
        a: "Brian Tracy",
        c: "82",
        h: "<blockquote>&ldquo;The only person you should try to be better than is the person you were yesterday.&rdquo; &mdash; <footer>Brian Tracy</footer></blockquote>",
    },
    {
        q: "Conflict cannot survive without your participation. ",
        a: "Wayne Dyer",
        c: "52",
        h: "<blockquote>&ldquo;Conflict cannot survive without your participation. &rdquo; &mdash; <footer>Wayne Dyer</footer></blockquote>",
    },
    {
        q: "Only those who will risk going too far can possibly find out how far one can go.",
        a: "T.S. Eliot",
        c: "80",
        h: "<blockquote>&ldquo;Only those who will risk going too far can possibly find out how far one can go.&rdquo; &mdash; <footer>T.S. Eliot</footer></blockquote>",
    },
    {
        q: "Never take your position for granted and never let any favors you receive go to your head.",
        a: "Robert Greene",
        c: "90",
        h: "<blockquote>&ldquo;Never take your position for granted and never let any favors you receive go to your head.&rdquo; &mdash; <footer>Robert Greene</footer></blockquote>",
    },
    {
        q: "The most difficult thing is the decision to act, the rest is merely tenacity. The fears are paper tigers.",
        a: "Amelia Earhart",
        c: "105",
        h: "<blockquote>&ldquo;The most difficult thing is the decision to act, the rest is merely tenacity. The fears are paper tigers.&rdquo; &mdash; <footer>Amelia Earhart</footer></blockquote>",
    },
    {
        q: "Don't settle, and don't struggle.",
        a: "Naval Ravikant",
        c: "33",
        h: "<blockquote>&ldquo;Don't settle, and don't struggle.&rdquo; &mdash; <footer>Naval Ravikant</footer></blockquote>",
    },
    {
        q: "Seek not the good in external things;seek it in yourselves.",
        a: "Epictetus",
        c: "59",
        h: "<blockquote>&ldquo;Seek not the good in external things;seek it in yourselves.&rdquo; &mdash; <footer>Epictetus</footer></blockquote>",
    },
    {
        q: "Often in the real world, it's not the smart that get ahead, but the bold.",
        a: "Robert Kiyosaki",
        c: "73",
        h: "<blockquote>&ldquo;Often in the real world, it's not the smart that get ahead, but the bold.&rdquo; &mdash; <footer>Robert Kiyosaki</footer></blockquote>",
    },
    {
        q: "The degree of responsibility you take for your life determines how much change you can create in it.",
        a: "Celestine Chua",
        c: "100",
        h: "<blockquote>&ldquo;The degree of responsibility you take for your life determines how much change you can create in it.&rdquo; &mdash; <footer>Celestine Chua</footer></blockquote>",
    },
    {
        q: "Concentrate all your thoughts upon the work at hand. The sun's rays do not burn until brought to focus.",
        a: "Alexander Graham Bell",
        c: "103",
        h: "<blockquote>&ldquo;Concentrate all your thoughts upon the work at hand. The sun's rays do not burn until brought to focus.&rdquo; &mdash; <footer>Alexander Graham Bell</footer></blockquote>",
    },
    {
        q: "You are what you believe in. You become that which you believe you can become.",
        a: "Bhagavad Gita",
        c: "78",
        h: "<blockquote>&ldquo;You are what you believe in. You become that which you believe you can become.&rdquo; &mdash; <footer>Bhagavad Gita</footer></blockquote>",
    },
    {
        q: "Take responsibility of your own happiness, never put it in other people's hands.",
        a: "Roy T. Bennett",
        c: "80",
        h: "<blockquote>&ldquo;Take responsibility of your own happiness, never put it in other people's hands.&rdquo; &mdash; <footer>Roy T. Bennett</footer></blockquote>",
    },
];
